import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApplicationStatus } from 'src/enums/application-status.enum';
import { ApiCommission, ApiSpecialities } from 'src/http';
import { useResources } from '../../hooks';
import { getApplications } from '../../thunks/application-thunks';
import { Speciality } from '../applications';
import { ApplicationsPanel } from '../applications/applications-panel';
import { Commission } from '../commissions';
import { DataGrid } from '../data-grid';
import { DataTableFooter } from '../data-table/data-table-footer';
import { Loader } from '../loader';
import { Page } from '../page';
import { CertificatesCard } from './certificates-card';

export const Certificates: ComponentType = () => {
  const { t } = useTranslation();
  const {
    list: { hits, isLoading, total },
    query,
    handleQueryUpdate,
  } = useResources({
    entity: 'application',
    onGetAll: getApplications,
    defaultParams: {
      embed: 'user',
      pageItems: 10,
      status: ApplicationStatus.PASSED,
    },
  });

  const [specialities, setSpecialities] = useState<Speciality[] | null>(null);
  const getSpecialities = async () => {
    let params = {
      skip: 0,
      take: 999,
      order: '-id',
    };
    try {
      const data = await ApiSpecialities.fetchAll(params);
      setSpecialities(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [commissions, setCommissions] = useState<Commission[] | null>(null);
  const getCommissions = async () => {
    let params = {
      skip: 0,
      take: 999,
      order: '-id',
    };
    try {
      const data = await ApiCommission.fetchAll(params);
      setCommissions(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  useEffect(() => {
    getSpecialities();
    getCommissions();
  }, []);

  const view = () => {
    if (isLoading) return <Loader minHeight="50vh" />;
    return (
      // <DataGridApplication
      //   data={hits}
      //   itemProps={{ xs: 6 }}
      //   spacing={2}
      //   renderItem={(item) => <CertificatesCard item={item} />}
      // />
      <>
        <ApplicationsPanel
          {...{
            query,
            onUpdate: handleQueryUpdate,
            SearchFieldProps: {
              placeholder: t(
                'action.search.by.applications.placeholder',
                '№, Ф.И.О., ПИНФЛ, серия и номер паспорта'
              ),
            },
          }}
        />
        <DataGrid
          data={hits}
          itemProps={{ xs: 6 }}
          spacing={2}
          renderItem={(item) => (
            <CertificatesCard item={item} specialities={specialities} commissions={commissions} />
          )}
        />
        <br />
        <DataTableFooter {...{ total, query, onUpdate: handleQueryUpdate }} />
      </>
    );
  };

  return <Page title={t('certificates', 'Сертификаты')}>{view()}</Page>;
};
